import { LayerModelDc } from "@evergis/api";
import { Margin, PrintInfo, PrintLayer, TemplateModel } from "../../../interfaces/print";
import { legendPositionTemplateConfMap } from "./legendPositionTemplateConfMap";
import { pixelsToMms, PRINT_DPI } from "./pixelsToMms";
import { templateConfig } from "./templateConfig";

export class PrintTemplate<Template extends TemplateModel> {
  constructor(protected readonly printInfo: PrintInfo) {}

  public async serialize(): Promise<Template> {
    return null;
  }

  protected getPrintFormatInfo() {
    const { margin, name: templateName } = this.resolveTemplateConfig();
    const { printFile } = this.printInfo;
    const paperWidth = pixelsToMms(this.getWidth() + margin[Margin.Left] + margin[Margin.Right]);

    return { fileName: printFile.name, fileFormat: printFile.ext, paperWidth, dpi: PRINT_DPI, margin, templateName };
  }

  protected getWidth() {
    const { rectangle } = this.printInfo;

    return (rectangle && rectangle.width) || 0;
  }

  protected createLayerModel = ({ layerServiceName, layerOpacity }: PrintLayer): LayerModelDc => ({
    layerServiceName,
    layerOpacity,
  });

  protected resolveTemplateConfig() {
    const { settings } = this.printInfo;
    const { legend } = settings;

    if (!legend) {
      return templateConfig.Default;
    }

    return legendPositionTemplateConfMap[legend.position] || templateConfig.Default;
  }
}
